import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-changelog-btn',
  templateUrl: './changelog-btn.component.html',
  styleUrls: ['./changelog-btn.component.scss']
})
export class ChangelogBtnComponent {
  @Input()
  isLoadingData: boolean;

  @Output()
  showChangelog: EventEmitter<void> = new EventEmitter();

  constructor(private auth: AuthService) {}

  onClick() {
    if (this.auth.isAuthenticated()) {
      this.showChangelog.emit();
    } else {
      this.auth.login();
    }
  }
}
